import React from "react";

import "./projectNavigator.css";

class projectNavigator extends React.Component {
  render() {
    return (
      <div className={this.props.className} onClick={this.props.onClickHandler}>
        <div className="content">
          <div className="triangle" />
          <div className="title-container">
            <div className="title-container-medium">
              <h1 className="display-font">
                {this.props.project.fields.title}
              </h1>
            </div>
          </div>
          <img
            src={this.props.project.fields.previewImage.fields.file.url}
            alt="something"
          />
        </div>
      </div>
    );
  }
}
export default projectNavigator;
